import React, { Component } from 'react';

import classNames from 'classnames';
import { Checkbox } from 'components/input/checkbox';
import PropTypes from 'prop-types';

import './ChecklistItem.scss';

class ChecklistItem extends Component {
  static propTypes = {
    className: PropTypes.string,
    formatItem: PropTypes.func,
    onChange: PropTypes.func,
    id: PropTypes.string,
    item: PropTypes.object,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    positionIcon: PropTypes.string,
    classIcon: PropTypes.string
  };

  static defaultProps = {
    positionIcon: '',
    icon: '',
    classIcon: '',
    className: ''
  };

  render() {
    const {
      id,
      name,
      className,
      item,
      formatItem,
      onChange,
      disabled,
      positionIcon,
      icon,
      classIcon
    } = this.props;
    const classComponent = classNames('checklist__item', className);
    const labelValue = formatItem ? formatItem(item) : item.name;

    return (
      item && (
        <li className={classComponent}>
          <Checkbox
            disabled={disabled}
            id={id}
            name={name}
            value={item.value}
            checked={item.checked}
            onChange={onChange}
            positionIcon={positionIcon}
            icon={icon}
            classIcon={classIcon}
          >
            {labelValue}
          </Checkbox>
        </li>
      )
    );
  }
}

export default ChecklistItem;
